// extracted by mini-css-extract-plugin
module.exports = {"correctedSearchTerm":"CorrectedSearchTerm_correctedSearchTerm__22YKh","correctedSearchTerm__copy":"CorrectedSearchTerm_correctedSearchTerm__copy__7fRmX"};